export default "__VITE_ASSET__DFQeAsaO__"